import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Newsflash } from '@solar-web/newsflash/bundle';
// import '@webcomponents/scoped-custom-element-registry';
import { PortalMessageService, PortalMessagesResponse, MessageBody } from '../../services/portal-messages.service';
import { take, delay } from 'rxjs/operators';

@Component({
	selector: 'newsflash-container',
	encapsulation: ViewEncapsulation.Emulated,
	template: `<celine-newsflash #newsflash
		(read)="read($event)"
    	(dismissed)="dismissed($event)"
    	(continue)="continue($event)"
	></celine-newsflash>`
})

export class NewsflashComponent implements OnInit {
	@ViewChild('newsflash') newsflash!: Newsflash;
	private portalMessages: PortalMessagesResponse;

	constructor (private portalMessageService: PortalMessageService) {
		if (customElements.get('celine-newsflash') === undefined)
			window.customElements.define('celine-newsflash', Newsflash);
		else
			console.warn('celine-newsflash custom element is already defined');
	}

	ngOnInit(): void {
		this.portalMessageService.getPortalMessages()
			.pipe(take(1))
			.delay(200)
			.subscribe((portalMessages: PortalMessagesResponse) => {
				this.portalMessages = portalMessages;
				this.newsflash.nativeElement.posts = portalMessages.portalMessages;
				if (portalMessages.count > 0) this.newsflash.nativeElement.showDialog();
			});
	}

	dismissed($event: any) {

	}

	continue($event: any) {
		const body = {
			"messageId": $event.detail.messageId,
			"applicationIds": $event.detail.applicationIds,
		} as MessageBody
		this.portalMessageService.dismissMessage(body)
			.pipe(take(1))
			.subscribe((response: any) => { })
	}

	read($event: any) {
		const body = {
			"messageId": $event.detail.messageId,
			"applicationIds": $event.detail.applicationIds,
		} as MessageBody
		this.portalMessageService.readMessage(body)
			.pipe(take(1))
			.subscribe((response: any) => { })
	}
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/newsflash/newsflash.component.ts